import {
  ComponentType,
  ForwardedRef,
  forwardRef,
  ForwardRefRenderFunction,
  PropsWithoutRef,
} from 'react'

export type ForwardedRefProp<RefType> = { forwardedRef: ForwardedRef<RefType> }

// Want to know more?
// Please check ADR file: 0009-forward-ref-wrapper.md
// Oh wait that file doesn't exist, and there is absolutely no documentation about this code.
// It is so fragile that it's typing has to be constantly maintained.
export function forwardRefWrapper<
  PROPS,
  RefType = PROPS extends ForwardedRefProp<infer T> ? T : HTMLElement,
>(Component: ComponentType<PROPS & ForwardedRefProp<RefType>>) {
  type CPROP = Omit<PROPS, 'forwardedRef'>
  const component: ForwardRefRenderFunction<RefType, PropsWithoutRef<CPROP>> = (props, ref) => (
    <Component {...(props as PROPS)} forwardedRef={ref} />
  )

  component.displayName = `RefForwarded${Component.displayName ?? Component.name}`

  return forwardRef<RefType, CPROP>(component)
}
